import React from 'react';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import './Large-Image-Component-With-Body.scss';

const LargeImageComponentWithBodyPreview = (props) => {
  const { config } = props;

  return (
    <div className='large-image-with-body'>
      {config && (
        <div>
          <div className='preview-title'>{config?.titleH1 ? config?.titleH1 : 'H1 Title'}</div>
          {!config.isVideo && (
            <div
              style={{
                backgroundColor: config?.backgroundColor || '#8f8f8f',
              }}
              className={`large-image-with-body-box ${config?.shadowOverlay ? 'shadowed-img' : ''}`}
            >
              <div
                className='d-flex align-items-center justify-content-center h-100 large-image-with-background-image-container'
                style={
                  config?.imgURL && {
                    backgroundImage: 'url(' + ASSET_URL + config?.imgURL + ')',
                    backgroundSize: 'cover',
                  }
                }
              >
                <div className='slide-title'>{config?.imgURL ? '' : 'Large Image'}</div>
              </div>
            </div>
          )}
          {config?.isVideo && (
            <div className={`${config?.shadowOverlay ? 'shadowed-img' : ''}`}>
              <video
                width={'100%'}
                height={'100%'}
                autoPlay
                loop={config?.loopPlayBack}
                preload='auto'
                src={config?.videoURL}
                muted
              />
            </div>
          )}
          <div className='preview-body mb-2'>
            <p className='preview-breaks'>{config?.body ? config?.body : 'Body'}</p>
          </div>
          {config?.cta?.isActive && (
            <div className='preview-cta mb-2'>{config?.cta.title ? config?.cta.title : 'CTA'}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default LargeImageComponentWithBodyPreview;
